import * as z from 'zod';

const phoneRegex = /^[a-zA-Z0-9\s'\-.+()]*$/;
const curpRegex =
  /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
const nameRegex = /^[a-zA-Z\s'-]*$/;

export const defaultSchemaHeaders = {
  0: 'Nombre',
  1: 'Apellido',
  2: 'Segundo Apellido',
  3: 'Correo',
  4: 'Teléfono Celular',
  5: 'CURP',
  6: 'Rol',
  7: 'Sucursal',
};

const userExportSchema = z.object({
  Nombre: z
    .string({
      required_error: 'El nombre es requerido',
      invalid_type_error: 'El formato del nombre es incorrecto',
    })
    .max(128, { message: 'El nombre no puede tener más de 128 caracteres' })
    .regex(nameRegex, 'El nombre tiene caracteres inválidos'),
  Apellido: z
    .string({
      required_error: 'El apellido es requerido',
      invalid_type_error: 'El formato del apellido es incorrecto',
    })
    .max(128, { message: 'El apellido no puede tener más de 128 caracteres' })
    .regex(nameRegex, 'El apellido tiene caracteres inválidos'),
  'Segundo Apellido': z
    .string({
      required_error: 'El segundo apellido es requerido',
      invalid_type_error: 'El formato del segundo apellido es incorrecto',
    })
    .max(128, {
      message: 'El segundo apellido no puede tener más de 128 caracteres',
    })
    .regex(nameRegex, 'El segundo apellido tiene caracteres inválidos')
    .optional(),
  Correo: z
    .string({
      required_error: 'El correo es requerido',
      invalid_type_error: 'El formato del correo es incorrecto',
    })
    .email({
      message: 'El correo no es válido',
    }),
  'Teléfono Celular': z.preprocess(
    value => {
      if (typeof value === 'number') {
        return value.toString();
      }

      return value;
    },
    z
      .string({
        required_error: 'El teléfono es requerido',
        invalid_type_error: 'El formato del teléfono es incorrecto',
      })
      .regex(phoneRegex, { message: 'El teléfono no es válido' })
      .max(10, { message: 'El teléfono debe ser 10 dígitos exactos' })
      .optional()
  ),
  CURP: z
    .string({
      required_error: 'El CURP es requerido',
      invalid_type_error: 'El formato del CURP es incorrecto',
    })
    .regex(curpRegex, 'El CURP no es válido')
    .optional(),
  Rol: z
    .string({
      required_error: 'El rol es requerido',
      invalid_type_error: 'El formato del rol es incorrecto',
    })
    .max(32, { message: 'El rol no puede tener más de 32 caracteres' }),
  Sucursal: z.string({
    required_error: 'La sucursal es requerida',
    invalid_type_error: 'El formato de la sucursal es incorrecto',
  }).optional(),
});

export default userExportSchema;
